import { money } from "@/lib/format";

export const C = { mint: "#5fbf9a", petrol: "#142F39", gold: "#e2b852", coral: "#f08a6c", muted: "#cfd8d4" };

export const Grad = ({ id, color, from = 0.9, to = 0.35 }) => (
  <linearGradient id={id} x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stopColor={color} stopOpacity={from} /><stop offset="100%" stopColor={color} stopOpacity={to} /></linearGradient>
);

export const axis = { tickLine: false, axisLine: false, tick: { fontSize: 11, fill: "currentColor", opacity: 0.55 }, dy: 6 };
export const cursor = { fill: "hsl(var(--muted))", opacity: 0.6, radius: 10 };
export const anim = { animationDuration: 900, animationEasing: "ease-out" };

export const ChartTooltip = ({ active, payload, label, names = {}, fmt = (v) => money(v), title }) => {
  if (!active || !payload?.length) return null;
  return (
    <div className="min-w-36 rounded-xl border border-border/60 bg-background/90 px-3 py-2 text-xs shadow-xl backdrop-blur-md" data-testid="chart-tooltip">
      <div className="mb-1 font-bold capitalize">{title ? title(payload[0].payload) : label}</div>
      {payload.filter((p) => p.value != null).map((p) => (
        <div key={p.dataKey} className="flex items-center justify-between gap-4">
          <span className="flex items-center gap-1.5 text-muted-foreground"><i className="h-2 w-2 rounded-full" style={{ background: p.stroke && p.stroke !== "none" ? p.stroke : p.payload?.fillColor || p.color }} />{names[p.dataKey] || p.name}</span>
          <span className="font-semibold tabular-nums">{fmt(p.value)}</span>
        </div>))}
    </div>
  );
};
